import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'submit form': 'search',
  },

  initialize({ placeholder }) {
    this.listenTo(this.collection, 'filtered', this.clearSearch);
    this.placeholder = placeholder;
  },

  context() {
    return {
      placeholder: this.placeholder,
    };
  },

  clearSearch() {
    this.$('input').val('');
  },

  search(e) {
    e.preventDefault();
    const term = (this.$('input').val() || '').trim();
    if (term.length > 0) {
      this.searchTerm(term);
    } else {
      // this check can be removed once all list pages use a PageableBase
      if (this.collection.resetToFirstPage) {
        this.collection.resetToFirstPage();
      } else {
        this.collection.trigger('filtered');
      }
    }
  },

  searchTerm(term) {
    /* Override this method to perform a custom search */
    this.collection.searchById(term);
  }
});



// WEBPACK FOOTER //
// ./app/components/list/search/index.js